import { useLang } from '@/i18n';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
export default function Comp() {
    const { t } = useLang('theProduct.SectionA7');

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} />
            <EcoSpaceSmall />
            <EcoImgVideo pc={`https://websiteoss.ecoflow.com/upload/image/1741259935360/Group%201000008121.jpg`} className="SectionA7-img" />
        </div>
    );
}
